"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSharedPreviousVideoPreferences = exports.setSharedCameraAndScreenShareSourcesInProgram = exports.getSharedPreviousVideoPreferences = exports.getSharedCameraAndScreenShareSourcesInProgram = void 0;
/**
 * This module provides a shared state for managing video preferences and sources.
 *
 * The reason for this shared state is to facilitate communication between the
 * Chime `handleRemoveVideoSourcesDidChange` event and the program updates received
 * from the app. Ideally, we would retrieve the previous state from Chime when
 * `handleRemoveVideoSourcesDidChange` is called and then only update what has changed.
 * Unfortunately, those states are cleared out prior to that event being fired.
 *
 * This cache exists to:
 * 1. Remember the previous priority of all our video feeds and update them accordingly.
 * 2. Store information about who is on stage so that the Chime event handler has access to this.
 */

var videoSharedState = function () {
  var cameraAndScreenShareSourcesInProgram = [];
  var previousVideoPreferences = [];
  return {
    /**
     * Get the shared camera and screen share sources that are in the program.
     * @returns {Array} The current camera and screen share sources in the program.
     */
    getSharedCameraAndScreenShareSourcesInProgram: function getSharedCameraAndScreenShareSourcesInProgram() {
      return cameraAndScreenShareSourcesInProgram;
    },
    /**
     * Set the shared camera and screen share sources that are in the program.
     * @param {Array} value - The new camera and screen share sources in the program.
     */
    setSharedCameraAndScreenShareSourcesInProgram: function setSharedCameraAndScreenShareSourcesInProgram(value) {
      cameraAndScreenShareSourcesInProgram = value;
    },
    /**
     * Get the shared previous video preferences that we're last set in chime.
     * @returns {Array} The current previous video preferences.
     */
    getSharedPreviousVideoPreferences: function getSharedPreviousVideoPreferences() {
      return previousVideoPreferences;
    },
    /**
     * Set the shared previous video preferences.
     * @param {Array} value - The new previous video preferences.
     */
    setSharedPreviousVideoPreferences: function setSharedPreviousVideoPreferences(value) {
      previousVideoPreferences = value;
    }
  };
}();
var getSharedCameraAndScreenShareSourcesInProgram = exports.getSharedCameraAndScreenShareSourcesInProgram = videoSharedState.getSharedCameraAndScreenShareSourcesInProgram,
  setSharedCameraAndScreenShareSourcesInProgram = exports.setSharedCameraAndScreenShareSourcesInProgram = videoSharedState.setSharedCameraAndScreenShareSourcesInProgram,
  getSharedPreviousVideoPreferences = exports.getSharedPreviousVideoPreferences = videoSharedState.getSharedPreviousVideoPreferences,
  setSharedPreviousVideoPreferences = exports.setSharedPreviousVideoPreferences = videoSharedState.setSharedPreviousVideoPreferences;